

(() => {
  function initialiseSelectors() {
    document.querySelectorAll('.dyrt-multi').forEach(root => {
      if (root.dataset.ready === 'true') return;

      const inputs = [...root.querySelectorAll(
        'input[data-variant]'
      )];

      const count = root.querySelector('[data-count]');
      const total = root.querySelector('[data-total]');
      const button = root.querySelector('[data-add]');
      const message = root.querySelector('[data-message]');

      if (!button || !inputs.length) return;

      root.dataset.ready = 'true';

      function updateTotal() {
        let quantity = 0;
        let cents = 0;

        inputs.forEach(input => {
          const n = Math.max(
            0,
            Math.floor(Number(input.value) || 0)
          );

          quantity += n;
          cents += n * Number(input.dataset.price);
        });

        if (count) count.textContent = quantity;

        if (total) {
          total.textContent = new Intl.NumberFormat(
            'en-AU',
            {
              style: 'currency',
              currency: 'AUD'
            }
          ).format(cents / 100);
        }
      }

      inputs.forEach(input => {
        input.addEventListener('input', updateTotal);
      });

      button.addEventListener('click', async () => {
        if (button.disabled) return;

        const selected = inputs.filter(input =>
          Number.isInteger(Number(input.value)) &&
          Number(input.value) > 0 &&
          !input.disabled
        );

        if (!selected.length) {
          if (message) {
            message.textContent =
              'Please select a shirt size.';
          }
          return;
        }

        const section = root.closest(
          '.shopify-section'
        ) || document;

        // Find rider details for this product.
        const fields = [...section.querySelectorAll(
          '.custom-moto-fields input[name^="properties["], ' +
          '.dyrt-rider-details input[name^="properties["]'
        )];

        // Validate required rider details.
        if (fields.length && fields.some(field =>
          field.required && !field.value.trim()
        )) {
          if (message) {
            message.textContent =
              'Please complete all rider details.';
          }
          return;
        }

        // Save rider details.
        const properties = {};

        fields.forEach(field => {
          const match = field.name.match(
            /^properties\[(.+)\]$/
          );

          if (match && field.value.trim()) {
            properties[match[1]] =
              field.value.trim();
          }
        });

        // Save design colours.
        const colourSelect = section.querySelector(
          '.dyrt-design-colours select[name="properties[Design Colours]"], ' +
          '.custom-moto-fields select[name="properties[Design Colours]"]'
        );

        if (colourSelect) {
          if (!colourSelect.value) {
            if (message) {
              message.textContent =
                'Please choose your design colours.';
            }
            return;
          }

          properties['Design Colours'] =
            colourSelect.value;
        }

        // NEW: Save optional additional notes.
        const notesField = section.querySelector(
          '.dyrt-customer-notes textarea[name="properties[Additional Notes]"]'
        );

        if (notesField && notesField.value.trim()) {
          properties['Additional Notes'] =
            notesField.value.trim();
        }

        // Build cart items for selected sizes.
        const items = selected.map(input => ({
          id: Number(input.dataset.variant),
          quantity: Number(input.value),
          properties: { ...properties }
        }));

        button.disabled = true;

        if (message) {
          message.textContent =
            'Adding shirts to cart...';
        }

        try {
          const response = await fetch(
            (window.Shopify?.routes?.root || '/') +
              'cart/add.js',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ items })
            }
          );

          const result = await response.json();

          if (!response.ok) {
            throw new Error(
              result.description ||
              'Unable to add shirts.'
            );
          }

          window.location.href =
            (window.Shopify?.routes?.root || '/') +
            'cart';

        } catch (error) {
          if (message) {
            message.textContent =
              error.message || 'Unable to add shirts.';
          }

          button.disabled = false;
        }
      });

      updateTotal();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseSelectors
    );
  } else {
    initialiseSelectors();
  }

  document.addEventListener(
    'shopify:section:load',
    initialiseSelectors
  );
})();
